import { useMutation } from '@tanstack/react-query';

import { MutationFunction, useRequest } from '@frontend/api';

export type UseSplitPdfPartFileParams = {
  fileUuid: string;
};

export type SplitPdfPartFileRequestBody = {
  quoteId: number;
};

export const getSplitPdfPartFileMutationKey = (
  params: UseSplitPdfPartFileParams,
) => ['parts', 'files', params.fileUuid, 'splitPdf'] as const;

export const useSplitPdfPartFile: MutationFunction<
  never,
  SplitPdfPartFileRequestBody,
  [UseSplitPdfPartFileParams]
> = (params, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  const urlPath = `/parts/files/${params.fileUuid}/split_pdf`;
  const mutationKey = getSplitPdfPartFileMutationKey(params);

  return useMutation(
    (body) =>
      request(urlPath, {
        init: {
          method: 'POST',
          body,
        },
      }),
    {
      ...queryOptions,
      mutationKey,
    },
  );
};
